import { ADD_JOURNAL_PAGE, SAVE_JOURNAL_PAGE, GET_JOURNAL_SUCCESS, TOGGLE_JOURNAL_MORE } from "../actions";

const initialState = {
    loading: true,
    posts: [],
    page: 1,
    hasmore: true,
    spage: 0
}

export const journalReducer = (state = initialState, action) => {
    switch(action.type){
        case ADD_JOURNAL_PAGE:
            return { ...state, loading: true, page: state.page + 1 }
        case GET_JOURNAL_SUCCESS:
            return { ...state, loading: false, posts: [...state.posts,...action.journals.data] }
        case TOGGLE_JOURNAL_MORE:
            return { ...state, loading: false, posts: [...state.posts,...action.journals.data], hasmore: false }
        case SAVE_JOURNAL_PAGE:
            return { ...state, spage: state.page }
        
        default: return state
    }
}